import { render, staticRenderFns } from "./PollUserReports.vue?vue&type=template&id=57836f2b&"
import script from "./PollUserReports.vue?vue&type=script&lang=js&"
export * from "./PollUserReports.vue?vue&type=script&lang=js&"
import style0 from "./PollUserReports.vue?vue&type=style&index=0&id=57836f2b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports